import React, { Component } from 'react';
import { Button, FileUploader, InlineNotification } from 'carbon-components-react';
import uploadIcon from '@carbon/icons-react/lib/upload/16';
import PropTypes from 'prop-types';
import { fileUpload } from '../../helpers/api/api';
import {Megabyte, entitiesLabels} from '../../helpers/Constants';
import { attachmentTablePrivacyText } from './AttachmentTable';

export default class FileUpload extends Component {
    fileUploader;

    constructor(props) {
        super(props);
        const hocCardTranslateGHRS = this.props.isTranslate ? window.sessionStorage.getItem("hocCardTranslate") : null; //RITM0954296
        this.state = {
            canUpload: false,
            isFileValid: true,
            validationErrorTitle: '',
            validationErrorSubTitle: '',
            statusUpload: 'edit',
            hocCardTranslateGHSRFields: JSON.parse(hocCardTranslateGHRS), //RITM0954296
        };
        this.onFileUploadChange = this.onFileUploadChange.bind(this);
        this.clearFiles = this.clearFiles.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    clearFiles = () => {
        this.fileUploader.clearFiles();
        this.setState(() => ({
            canUpload: false,
            isFileValid: true,
            validationErrorTitle: '',
            validationErrorSubTitle: '',
        }));
    };

    isTotalFilesSizeExceeded = (file, isImagefile) => {
        const totalImageSizeLimitExceeded = isImagefile ? this.props.sumImageAttachmentSize + file.size >= Megabyte.THREEMEGABYTE : false;
        const totalFilesSizeLimitExceeded = this.props.totalFilesSizeLimit != null ? this.props.sumAttachmentSize + file.size >= this.props.totalFilesSizeLimit : false
        return totalImageSizeLimitExceeded || totalFilesSizeLimitExceeded;
    };

    isSingleFileSizeExceeded = (file, isImagefile) => {
        if (isImagefile) return file.size >= Megabyte.THREEMEGABYTE;
        const singleFileSizeLimit = this.props.singleFileSizeLimit ?? Megabyte.FOURMEGABYTE * 2;
        return file.size >= singleFileSizeLimit;
    };

    onFileUploadChange = (evt) => {
        this.setState(() => ({ statusUpload: "edit" }));
        const file = evt.target.files[0] ?? null;
        if (file === null) return;

        const fileName = file.name;
        const isImagefile = file.type.includes("image");
        let validationErrorTitle = "";
        let validationErrorSubTitle = "";

        switch (true) {
            case this.isSingleFileSizeExceeded(file, isImagefile):
                validationErrorTitle = `${fileName} exceeds size limit.`;
                validationErrorSubTitle = `${isImagefile ? entitiesLabels.THREEMEGABYTEMAXSIZE : (this.props.maxSingleSizeErrorLabel ?? entitiesLabels.EIGHTMEGABYTEMAXSIZE) + "."} ${entitiesLabels.SELECTNEWFILE}`;
                break;
            case this.isTotalFilesSizeExceeded(file, isImagefile):
                validationErrorTitle = `Sum of file size exceeds size limit. ${isImagefile ? `(${this.availableImageAttachmentSize(Megabyte.THREEMEGABYTE)}).` : ""}`;
                validationErrorSubTitle = `${isImagefile ? "The sum of the size of the images cannot exceed 3MB" : this.props.maxTotalSizeErrorLabel ?? entitiesLabels.EIGHTMEGABYTEMAXSIZE}. ${entitiesLabels.SELECTNEWFILE}`;
                break;
            default:
        }

        const anyError = Boolean(validationErrorTitle || validationErrorSubTitle);
        this.setState(() => ({
            canUpload: !anyError,
            isFileValid: !anyError,
            validationErrorTitle,
            validationErrorSubTitle,
        }));
    };

    handleSubmit = async (event) => {
        event.preventDefault();
        this.setState(() => ({
            canUpload: false,
            isFileValid: true,
            validationErrorTitle: '',
            validationErrorSubTitle: '',
            statusUpload: 'uploading',
        }));
        const file = event.target.inputFile.files[0];
        const fileName = file.name;
        const fileIdentifier = `${this.props.StoragePath}_${new Date().getTime()}_${fileName}`;
        const formData = new FormData();
        formData.append('File', file);
        formData.append('Container', this.props.Container);
        formData.append('StoragePath', this.props.StoragePath);
        formData.append('FileIdentifier', fileIdentifier);

        try {
            await fileUpload.post(formData);
            const data = { identifier: fileName, blobName: fileIdentifier };
            this.setState(() => ({
                canUpload: false,
                isFileValid: true,
                validationErrorTitle: '',
                validationErrorSubTitle: '',
                statusUpload: 'complete',
            }));
            this.fileUploader.clearFiles();
            this.props.onUpload(data, file.name, file.type, file.size);
        } catch (error) {
            console.error(error);
            this.setState(() => ({
                canUpload: true,
                isFileValid: false,
                validationErrorTitle: 'An error occurred while uploading file: ',
                validationErrorSubTitle: error.message,
                statusUpload: 'edit',
            }));
        }
    };

    availableImageAttachmentSize = (sizeLimit) => {
        const sumOfImageAttachedSize = this.props.sumImageAttachmentSize ?? 0
        if (Megabyte.THREEMEGABYTE - sumOfImageAttachedSize > 0) return `${((sizeLimit - sumOfImageAttachedSize) / Megabyte.ONEMEGABYTE).toFixed(2)} ${entitiesLabels.MBAVAILABLE}`;
        return `0 ${entitiesLabels.MBAVAILABLE}`;
    };

  createCustomDescriptionForImage = () =>{
        const availableImageSize = this.props.sumImageAttachmentSize != null ? ("(" + this.availableImageAttachmentSize(Megabyte.THREEMEGABYTE) + ")") : ""
      if (this.state.hocCardTranslateGHSRFields?.attachmentUploadTitle == null)
          return `${this.props.acceptDescription} ${entitiesLabels.MAXSUMIMAGESIZE} ${availableImageSize}.`
      else
          return `${this.props.acceptDescription} ${this.state.hocCardTranslateGHSRFields?.msgMaxSumImageSize} ${availableImageSize}.`
    }

    returnDescription = () => {
    if(!this.props.acceptDescription) return "only files at 8mb or less"
    if(this.props.acceptDescription && this.props.accept?.includes('.jpeg')) return this.createCustomDescriptionForImage()
        return this.props.acceptDescription
    }

    render() {
        const notification = !this.state.isFileValid ? (
            <InlineNotification
                hideCloseButton={false}
                iconDescription="remove"
                kind="error"
                lowContrast
                notificationType="inline"
        onCloseButtonClick={() => {}}
                role="alert"
                subtitle={this.state.validationErrorSubTitle}
                title={this.state.validationErrorTitle}
            />
        ) : null;

        return (
            <div>
                <form onSubmit={this.handleSubmit} disabled={this.props.disabled || false}>
                    <div className="bx--file-container">
                        <FileUploader
                            ref={(node) => (this.fileUploader = node)}
              accept={this.props.accept  ? this.props.accept   :['.doc', '.docx', '.xls', '.xlsx', '.pptx', '.pptm', '.ppt', '.pdf','.jpeg', '.jpg', '.png', '.gif' ]}
                            buttonKind="primary"
                            buttonLabel={this.state.hocCardTranslateGHSRFields?.attachmentChooseAFileTitle || "Choose a file"}
                            title={this.props.title ?? null}
                            filenameStatus={this.state.statusUpload}
                            iconDescription="Choose"
                            labelDescription={this.returnDescription()}
                            labelTitle={this.state.hocCardTranslateGHSRFields?.attachmentsTitlePlaceholder || "(It is forbidden to upload photos which show people's faces. It is also forbidden to upload photos on which it is possible to recognize specific people)"}
                            multiple={false}
                            name="inputFile"
                            onClick={this.clearFiles}
                            onChange={this.onFileUploadChange}
                            disabled={this.props.disabled}
                            className="bx--content-detail"
              sumAttachmentSize = {this.props.sumAttachmentSize}
                        />
                        <Button
                            disabled={this.props.disabled}
                            kind="secondary"
                            onClick={this.clearFiles}
                            size="small"
                            type="button"
                        >
                            {this.state.hocCardTranslateGHSRFields?.attachmentClearSelectedFileTitle || "Clear selected file"}
                        </Button>
                        {this.state.canUpload ? (
                            <Button
                                disabled={this.props.disabled || !this.state.isFileValid}
                                type="submit"
                                renderIcon={uploadIcon}
                                size="small"
                                className="button-custom-updload"
                            >
                                {this.state.hocCardTranslateGHSRFields?.attachmentUploadTitle || "Upload"}
                            </Button>
                        ) : (
                            <Button
                                disabled
                                type="submit"
                                renderIcon={uploadIcon}
                                size="small"
                                className="button-custom-updload"
                            >
                                {this.state.hocCardTranslateGHSRFields?.attachmentUploadTitle || "Upload"}
                            </Button>
                        )}
                    </div>
                </form>
                {notification}
            </div>
        );
    }
}
FileUpload.propTypes = {
    Container: PropTypes.string,
    StoragePath: PropTypes.string,
    disabled: PropTypes.bool,
    onUpload: PropTypes.func.isRequired,
    isTranslate: PropTypes.bool, //RITM0954296
};
FileUpload.defaultProps = {
    Container: 'saipem',
    StoragePath: '',
    disabled: true,
    isTranslate: false, //RITM0954296
};
